import { Environment } from "../../../util";
import { FederatedObject } from "../types/FederatedObject";
import { getRemoteConfig } from "@ey/voltron-config";

export const getFederatedObject = (baseUri: string, module: string, scope: string = "kronos"): FederatedObject => {
  return {
    url: `${baseUri}/mfe/remoteEntry.js`,
    configUrl: `${baseUri}/config.js`,
    scope: scope,
    module: module,
  };
};

const kronosUrlCache = new Map<string, Promise<string | null>>();

export const getKronosUrl = async (herculesBaseUri: string): Promise<string | null> => {
  if (Environment.isDevelopment()) {
    return Environment.getConfigUrl("kronosWeb");
  }

  // getRemoteConfig never settles its promise once it has cached the origin, so only ever call it once per host.
  const cachedRequest = kronosUrlCache.get(herculesBaseUri);

  if (cachedRequest) {
    return cachedRequest;
  }

  const request: Promise<string | null> = getRemoteConfig(`${herculesBaseUri}/config.json`)
    .then((config) => config?.url?.kronos_web ?? null)
    .catch((error) => {
      console.error(`Failed to fetch Kronos URL for ${herculesBaseUri}:`, error);
      kronosUrlCache.delete(herculesBaseUri);
      return null;
    });

  kronosUrlCache.set(herculesBaseUri, request);

  return request;
};
